module.exports = __webpack_public_path__ + "img/lianxiwomen.162bb315.jpg";